<div class="container" *ngIf="isFormReady">
  <div class="row">
    <div class="col-12">
      <p-divider/>
      <form class="bg-light" [formGroup]="frm">
        <div class="p-fluid p-formgrid grid bg-light">
          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input
                type="text"
                style="width: 100%"
                pInputText
                formControlName="firstName"
                autocomplete="family-name"
              />
              <label class="required">Фамилия</label>
            </span>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['firstName'].hasError('required') &&
                frm.controls['firstName']?.touched
              "
              text="Обязательное поле"
            >
            </p-message>
          </div>
          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input
                type="text"
                style="width: 100%"
                pInputText
                formControlName="secondName"
                autocomplete="given-name"
              />
              <label class="required">Имя</label>
            </span>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['secondName'].hasError('required') &&
                frm.controls['secondName']?.touched
              "
              text="Обязательное поле"
            >
            </p-message>
          </div>
          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input
                type="text"
                style="width: 100%"
                pInputText
                formControlName="thirdName"
                autocomplete="additional-name"
              />
              <label>Отчество</label>
            </span>
          </div>

          <div class="p-field col-12 md:col-6">
            <span class="p-float-label">
              <textarea
                style="width: 100%"
                type="text"
                rows="2"
                pInputTextarea
                formControlName="workplace"
                [ngClass]="{ 'p-filled': frm.get('workplace')?.value !== '' }"
                autocomplete="organization"
              ></textarea>
              <label class="required">Место работы</label>
            </span>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['workplace'].hasError('required') &&
                frm.controls['workplace']?.touched
              "
              text="Обязательное поле"
            >
            </p-message>
          </div>
          <div class="p-field col-12 md:col-6">
            <span class="p-float-label">
              <textarea
                style="width: 100%"
                type="text"
                rows="2"
                pInputTextarea
                formControlName="position"
                [ngClass]="{ 'p-filled': frm.get('position')?.value !== '' }"
                autocomplete="organization-title"
              ></textarea>
              <label class="required">Должность</label>
            </span>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['position'].hasError('required') &&
                frm.controls['position']?.touched
              "
              text="Обязательное поле"
            >
            </p-message>
          </div>
          <div class="p-field col-12">
            <span class="p-float-label" *ngIf="!isMobile">
              <p-multiSelect
                id="speciality"
                formControlName="specialities"
                [placeholder]="specialitiesPlaceholder"
                [options]="lstSpecialities"
                display="chip"
                optionValue="value"
                optionLabel="label"
              ></p-multiSelect>
              <label for="speciality" class="required">Специальность</label>
            </span>
            <div class="form-group" *ngIf="isMobile">
              <label
                class="custom-float-label-selected required"
                for="specialities"
                >Специальность</label
              >
              <select
                multiple
                class="form-control"
                formControlName="specialities"
                id="specialities"
              >
                <option
                  *ngFor="let item of lstSpecialities"
                  [value]="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
            </div>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['specialities'].hasError('minlength') &&
                frm.controls['specialities']?.touched
              "
              text="Необходимо указать как минимум одну специальность"
            ></p-message>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['specialities'].hasError('maxlength') &&
                frm.controls['specialities']?.touched
              "
              text="Вы можете указать максимум 4 специальности"
            ></p-message>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['specialities'].hasError('required') &&
                frm.controls['specialities']?.touched
              "
              text="Необходимо указать как минимум одну специальность"
            >
            </p-message>
          </div>
          <div class="p-field col-12 md:col-6">
            <span class="p-float-label">
              <input
                type="tel"
                pInputText
                formControlName="phone"
                autocomplete="tel"
              />
              <label>Телефон</label>
            </span>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['phone'].hasError('pattern') &&
                frm.controls['phone']?.touched
              "
              text="Некорректный номер мобильного телефона"
            >
            </p-message>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['phone'].hasError('required') &&
                frm.controls['phone']?.touched
              "
              text="Обязательное поле"
            >
            </p-message>
          </div>
          <div class="p-field col-12 md:col-6">
            <span class="p-float-label">
              <input
                type="email"
                style="width: 100%"
                pInputText
                formControlName="email"
                autocomplete="email"
              />
              <label class="required">Email</label>
            </span>
            <p-message
              severity="error"
              *ngIf="
                (frm.controls['email'].hasError('email') ||
                  frm.controls['email'].hasError('pattern')) &&
                frm.controls['email']?.touched
              "
              text="Некорректный email"
            >
            </p-message>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['email'].hasError('required') &&
                frm.controls['email']?.touched
              "
              text="Обязательное поле"
            >
            </p-message>
          </div>

          <div class="col-12 md:col-12" style="margin-bottom: 1em">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
              </span>
              <p-autoComplete
                formControlName="filterGeo"
                [style]="{ width: '100%' }"
                [inputStyle]="{
                  width: '100%',
                  'border-top-left-radius': '0',
                  'border-bottom-left-radius': '0'
                }"
                [suggestions]="filteredGeo$ | async"
                (onSelect)="onSelectGeo($event)"
                [minLength]="3"
                placeholder="Найти город"
                field="display_name"
              ></p-autoComplete>
            </div>
          </div>
          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input
                type="text"
                style="width: 100%"
                pInputText
                formControlName="city"
              />
              <label class="required">Город</label>
            </span>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['city'].hasError('required') &&
                frm.controls['city']?.touched
              "
              text="Обязательное поле"
            >
            </p-message>
          </div>
          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input
                type="text"
                style="width: 100%"
                pInputText
                formControlName="region"
              />
              <label>Область/Край/Республика</label>
            </span>
            <p-message
              severity="error"
              *ngIf="
                frm.controls['region'].hasError('required') &&
                frm.controls['region']?.touched
              "
              text="Обязательное поле"
            >
            </p-message>
          </div>
          <div class="p-field col-12 md:col-4">
            <span class="p-float-label">
              <input
                type="text"
                style="width: 100%"
                pInputText
                formControlName="country"
                autocomplete="country"
              />
              <label>Страна</label>
            </span>
          </div>
        </div>
        <div *ngIf="isAdminEdit" class="p-field col-12 md:col-4">
          <span class="p-float-label">
            <p-dropdown
              [options]="lstRanks"
              formControlName="rank"
              [resetFilterOnHide]="true"
            ></p-dropdown>
            <label>Статус участия</label>
          </span>
        </div>
        <div *ngIf="isAdminEdit" class="p-field col-12 md:col-4">
          <span class="p-float-label">
            <p-dropdown
              [options]="lstChannels"
              formControlName="incomingChannel"
              [resetFilterOnHide]="true"
            ></p-dropdown>
            <label>Канал регистрации</label>
          </span>
        </div>
        <div
          *ngIf="isAdminEdit && !frm.valid"
          class="row justify-content-md-center"
        >
          <p-message severity="error" text="Форма невалидная"> </p-message>
          <pre>{{ frm.errors | json }}</pre>
        </div>
        <div *ngIf="!isAdminEdit" class="flex">
          <div class="flex flex-column gap-2 p-3 w-full">
            <!-- Переключатель -->
            <div class="flex align-items-center gap-2">
              <p-inputSwitch
                formControlName="isAgreeSendPersonalData"
              ></p-inputSwitch>
              <label for="isAgreeSendPersonalData" class="text-sm md:text-base">
                <a
                  href="https://www.antibiotic.ru/privacy_policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-primary font-medium no-underline"
                  >Являюсь специалистом здравоохранения и согласен на обработку
                  предоставленных данных</a
                >
              </label>
            </div>

            <!-- Сообщение об ошибке -->
            <p-message
              severity="error"
              *ngIf="
                frm.controls['isAgreeSendPersonalData'].hasError('required') &&
                frm.controls['isAgreeSendPersonalData'].touched
              "
              text="Подтвердите, что Вы являетесь специалистом здравоохранения и даете согласие на обработку персональных данных"
            >
            </p-message>
          </div>
        </div>
        <p-divider/>
        <div class="row justify-content-md-center mt-3 mb-3">
          <div class="col-12 col-md-6 text-center">
            <p-button
              label="{{ buttonCaption }}"
              [raised]="true"
              severity="success"
              (onClick)="onSubmit(frm)"
            />
          </div>
        </div>
        <!-- <pre>{{ frm.value | json }}</pre> -->
      </form>
    </div>
  </div>
</div>
